export const NAVBAR_NS = 'navbar'
export const DASHBOARD_NS = 'dashboard'
export const LOGIN_NS = 'login'
export const ALL_NS = 'all'

export const ns = [NAVBAR_NS, DASHBOARD_NS, LOGIN_NS, ALL_NS]

export const defaultNS = ALL_NS
